/**
 * @flow
 * @relayHash dc86cb7fd233571012a6c0a7b17b6707
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfirmCheckoutInput = {|
  orderId: string
|};
export type ConfirmCheckoutMutationVariables = {|
  input: ConfirmCheckoutInput
|};
export type ConfirmCheckoutMutationResponse = {|
  +confirmCheckout: ?{|
    +order: ?{|
      +orderid: ?string,
      +state: ?string,
    |}
  |}
|};
export type ConfirmCheckoutMutation = {|
  variables: ConfirmCheckoutMutationVariables,
  response: ConfirmCheckoutMutationResponse,
|};
*/


/*
mutation ConfirmCheckoutMutation(
  $input: ConfirmCheckoutInput!
) {
  confirmCheckout(input: $input) {
    order {
      orderid
      state
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfirmCheckoutInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderid",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ConfirmCheckoutMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "confirmCheckout",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmCheckoutPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfirmCheckoutMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "confirmCheckout",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmCheckoutPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ConfirmCheckoutMutation",
    "id": null,
    "text": "mutation ConfirmCheckoutMutation(\n  $input: ConfirmCheckoutInput!\n) {\n  confirmCheckout(input: $input) {\n    order {\n      orderid\n      state\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15a4b8198aa6a19be3f5d742cdb24c0d';

module.exports = node;
